export const TOOL_TASK = 'set-newsletter-subscriptions';
export const TOOL_TITLE = 'Set Newsletter Subscriptions';
export const TOOL_PROGRESS_LABEL = 'Bulk newsletter subscriptions updating progress...';
export const TOOL_STACK_OVERFLOW_MESSAGE = 'Please try again once updating user newsletter finishes';
export const FILE_NAME = 'Set-newsletter-subscriptions-report';
export const FILE_HEADERS = {
    userId: 'User Id',
    email: 'User Email',
    oldTypes: 'Old Newsletters',
    newTypes: 'New Newsletters',
    actionStatus: 'Action Status',
};

export const MODAL_WIDTH = 400;
